import { formatDateString } from 'bernie-l10n';

export const parseISODateString = (date: Date): string => {
  return formatDateString(date, { raw: 'yyyy-MM-dd' });
};
